import React from 'react';

// One painting shown as a plain picture. `painting` is an entry from paintings.json.
// The image loads straight from the Web Gallery of Art; the caption links back to its page there.
export function ArtWall({ painting }) {
  return (
    <div className="fm-art">
      <div className="fm-poster-big">
        <img src={painting.img} alt={painting.title} referrerPolicy="no-referrer" />
      </div>
      <p className="fm-art-caption">
        <strong>{painting.title}</strong>, {painting.artist}, {painting.date}
        {' · '}
        <a href={painting.page} target="_blank" rel="noopener noreferrer">
          see it at the Web Gallery of Art
        </a>
      </p>
    </div>
  );
}
